import update from 'react/lib/update';

export const ACTIONS_RECEIVED = 'hg/target/ACTIONS_RECEIVED';
export const initialState = {
  actions: [],
  actionsReceived: false
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ACTIONS_RECEIVED:
      return {
        ...state,
        actions: update(state.actions, {$push: [action.payload]}),
        actionsReceived: true
      };

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/target/target.js
 **/